import { render, staticRenderFns } from "./LeftSideTabs.vue?vue&type=template&id=3cfde58d&scoped=true&"
import script from "./LeftSideTabs.vue?vue&type=script&lang=js&"
export * from "./LeftSideTabs.vue?vue&type=script&lang=js&"
import style0 from "./LeftSideTabs.vue?vue&type=style&index=0&id=3cfde58d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfde58d",
  null
  
)

export default component.exports